<template>
  <div class="btx-ck-editor">
    <ckeditor
      :editor="editor"
      v-model="editorData"
      :disabled="disabled"
      :config="editorConfig"
    />
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editor: ClassicEditor,
      editorData: this.value,

      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "fontSize", // <-- add
          "fontFamily", // optional
          "|",
          "outdent",
          "indent",
          "|",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "|",
          "insertTable",
          "undo",
          "redo",
        ],
        fontSize: {
          options: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32],
          supportAllValues: true,
        },

        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableProperties",
            "tableCellProperties",
          ],
        },

        htmlSupport: {
          allow: [
            {
              name: /.*/,
              styles: true,
              attributes: true,
              classes: true,
            },
          ],
        },
      },
    };
  },

  watch: {
    value(val) {
      this.editorData = val;
    },
    editorData(val) {
      this.$emit("input", val);
    },
  },

  components: {
    ckeditor: CKEditor.component,
  },
};
</script>
